<template>
  <div class="flex flex-col overflow-auto w-full">
    <div class="space-y-2 w-full divide-y divide-mid-neutral-50">
      <div class="flex w-full gap-8 p-6">
        <div class="w-1/4 space-y-1">
          <h3 class="font-semibold text-dark-neutral-500">
            Specify the strategy
          </h3>
        </div>
        <div class="w-full">
          <PlanLockGuard>
            <TextInput
              ref="searchStrategySummaryInput"
              v-model="searchStrategySummary"
              :placeholder="`Summarize search strategy`"
              type="text"
              input-classes="w-2/3 pl-5 py-5  min-h-[200px] resize text-sm  hover:border-mid-neutral-50 focus:border-mid-neutral-50 "
              :multiline="true"
              :disabled="review.isPlanReadonly.value"
              @enter="(v) => updateSearchStrategySummary(v)"
              @blur="(v) => updateSearchStrategySummary(v)"
            />
          </PlanLockGuard>
        </div>
      </div>

      <InclusionCriteria />

      <PlanScreening />
    </div>
  </div>
</template>

<script setup lang="ts">
import TextInput from '@app/components/Global/Inputs/TextInput.vue'
import InclusionCriteria from './InclusionCriteria/InclusionCriteria.vue'
import PlanScreening from './PlanScreening/PlanScreening.vue'
import PlanLockGuard from '../PlanLockGuard.vue'
import useSnackbar from '@app/composables/use-snackbar'
import useLoading from '@app/composables/use-loading'
import { ref } from 'vue'
import { SnackbarState } from '@app/types'
import { HttpException } from '@core/exceptions/http.exception'
import { errorMessage } from '@app/utils/error-message'
import { injectStrict } from '@app/utils/injectStrict'
import { ReviewKey } from '../../use-review'

const review = injectStrict(ReviewKey)
const snackbar = useSnackbar()
const loading = useLoading()

const searchStrategySummary = ref(
  review.entity.value.plan?.searchStrategySummary,
)

async function updateSearchStrategySummary(newSearchStrategy: string) {
  try {
    loading.start()
    await review.updateSearchStrategySummary(newSearchStrategy)

    snackbar.success('Success')
  } catch (e) {
    const error = e as HttpException
    snackbar.show(SnackbarState.ERROR, errorMessage(error.response.data))
    if (error.response.data.statusCode >= 500) {
      throw e
    }
  } finally {
    loading.stop()
  }
}
</script>
